import { useState, useEffect } from 'react'

import { CoreApi } from '/src/helpers/CoreApi'
import useDebounce from '/src/hooks/useDebounce'
import Container from '/src/components/@common.blocks/Container'
import Select from '/src/components/@common.blocks/Select'
import FormField from '/src/components/@common.blocks/FormField'
import useInfiniteScroll from '/src/hooks/useInfiniteScroll'
import TableCollections from '/src/components/@common.blocks/TableCollections'

const SIZE_PER_PAGE = 10

const TableExtra = ({ filter, filterOnChange, sort, sortOnChange }) => {
  return (
    <div className='collections-list__filter'>
      <FormField>
        <Select
          options={[
            { title: 'Last 7d', value: 'volumeW' },
            { title: 'Last 24h', value: 'volumeD' },
            { title: 'Last 30d', value: 'volumeM' },
          ]}
          name='sort'
          value={sort}
          onSelect={sortOnChange}
        />
      </FormField>
      <FormField>
        <Select
          options={[
            { title: 'All chains', value: 'all' },
            { title: 'Ethereum', value: 'ethereum' },
            { title: 'Solana', value: 'solana' },
            { title: 'Polygon (Matic)', value: 'polygon' },
          ]}
          name='blockchain'
          value={filter.blockchain}
          onSelect={filterOnChange}
        />
      </FormField>
    </div>
  )
}

const CollectionsList = () => {
  const [collections, setCollections] = useState([])
  const [filter, setFilter] = useState({})
  const [sort, setSort] = useState('volumeW')
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useInfiniteScroll(fetchData)

  const query = useDebounce(filter, 500)

  async function fetchData(initialFetch = false) {
    const newPage = initialFetch ? 1 : page + 1

    const skeletonData = []
    for (let i = 0; i < SIZE_PER_PAGE; i++) {
      skeletonData.push({ loading: true })
    }

    setCollections([...collections, ...skeletonData])
    const data = await CoreApi.getCollections({
      ...query,
      sort,
      page: newPage,
      size: SIZE_PER_PAGE,
      min: 1,
    })

    setTimeout(() => {
      setCollections((prevState) => {
        const newState = initialFetch ? data : [...prevState, ...data]
        setPage(newPage)
        setLoading(false)
        return newState.filter((el) => !el.loading)
      })
    }, 500)
  }

  useEffect(() => {
    fetchData(true).catch((error) => {
      console.log(error)
    })
  }, [query, sort])

  const filterOnChange = (e) => {
    let value = e.target.value
    let name = e.target.name
    if (name === 'blockchain' && value === 'all') {
      value = undefined
    }
    setFilter((prevState) => ({ ...prevState, [name]: value }))
  }

  return (
    <section className='collections-list' id='collections'>
      <Container>
        <TableCollections
          title='Collections'
          sort={sort}
          data={collections}
          tableExtra={
            <TableExtra
              sort={sort}
              sortOnChange={(e) => setSort(e.target.value)}
              filter={filter}
              filterOnChange={filterOnChange}
            />
          }
        />
      </Container>
    </section>
  )
}

export default CollectionsList
